import { Outlet } from "react-router-dom";

const Dashboards = () => {
  return (
    <div className="flex-1 h-full overflow-auto">
      <Outlet />
    </div>
  );
};

export default Dashboards;
